import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-ink text-white">
      <p className="overline mb-6">404 · Off Route</p>
      <h1 className="font-serif text-5xl md:text-7xl mb-8">Page not found</h1>
      <Link to="/" className="btn-secondary" data-testid="notfound-home-link">
        Return Home
      </Link>
    </div>
  );
}
